import { render, staticRenderFns } from "./ListarResumo.vue?vue&type=template&id=682f8a14"
import script from "./ListarResumo.vue?vue&type=script&lang=js"
export * from "./ListarResumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports